import React from "react";
import { FormattedMessage } from "react-intl";

function HelpMessage() {
  return (
    <p className="mt-4 mb-2 text-center text-sm text-muted-text md:mb-0 md:text-left">
      <FormattedMessage id="giftCard.reachOutToSupport" />
      <a
        className="text-link-blue underline underline-offset-1 hover:text-sky-600"
        href="mailto:support@bluestacks.com"
      >
        support@bluestacks.com
      </a>
      .
    </p>
  );
}

export default HelpMessage;
